import { Injectable } from "@angular/core";
import * as LaunchDarkly from 'launchdarkly-js-client-sdk';

/**
 * This is a thin wrapper around launchdarkly-js-client-sdk.
 * Its API shape should be identical to Launch Darkly's.
 * Only purpose we serve is to integrate better with injection and unit tests.
 */
@Injectable({
  providedIn: 'root',
})
export class LaunchDarklyAdapter {
  private stub: LaunchDarkly.LDClient = {
    // Only need the bits that LaunchDarklyService is going to use.
    on: () => {},
    identify: () => {},
  } as any;

  constructor() {
  }

  /**
   * (envKey) false for a stub no-op client.
   */
  initialize(
    envKey: string,
    context: LaunchDarkly.LDContext,
    options?: LaunchDarkly.LDOptions
  ): LaunchDarkly.LDClient {
    if (!envKey) {
      return this.stub;
    } else {
      return LaunchDarkly.initialize(envKey, context, options);
    }
  }
}
